import React, {useState, useEffect} from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import Materi from '../components/Materi';
import Contact from '../components/Contact';
// import { FooterContainer } from '../container/footer'
const Home = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => { 
        setIsOpen(!isOpen)
    }

    useEffect(() => {
      document.title = "AED STAT ITS"
    }, [])
  return (
    <>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <Navbar toggle={toggle} />
        <HeroSection />
        <Materi />
        <Contact />
        {/* <FooterContainer /> */}
    </>
  )
}

export default Home